@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.events {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  z-index: 10;
}

.header {
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: space-between;
  width: 100%;

  &Icon {
    position: relative;
    width: 24px;
    height: 24px;

    &Notify::after {
      position: absolute;
      content: ' ';
      top: 3px;
      right: -1px;
      width: 10px;
      height: 10px;
      background-color: red;
      border-radius: 50%;
    }
  }

  &AvatarMenu {
    &Icon {
      svg {
        margin-right: 10px;
      }

      span {
        color: map.get(core.$fonts, fontSecondary);
      }
    }
  }

  &Right {
    display: flex;
    align-items: center;
    gap: 16px;

    &Notification {
      margin-right: 20px;

      svg {
        height: 24px;
        width: 24px;
      }
    }
  }

  &Left {
    align-items: center;
    display: flex;
    flex-direction: row;

    &Arrow {
      margin-right: 38px;

      @media screen and (max-width: core.$fullHD) and (min-width: core.$laptopL) {
        margin-right: 8px;
      }

      svg {
        height: 16px;
        width: 16px;
      }

      &Collapsed {
        margin-right: 38px;
        transform: rotate(180deg);

        @media screen and (max-width: core.$fullHD) and (min-width: core.$laptopL) {
          margin-right: 18px;
        }
      }
    }

    &Input {
      width: 300px;
    }
  }
}
